import React from 'react';
import { Container, Grid, Toolbar } from '@mui/material';

import { IItem } from 'api/catalog/models';
import ItemDetailsOptions from 'ui/ItemDetailsOptions';

import GenericItemInformation from './GenericItemInformation';
import ProductImage from './ProductImage';
import DetailedItemInformation from './DetailedItemInformation';

interface IProps {
  item: IItem;
}

const ItemDetails = ({ item }: IProps) => {
  return (
    <Container maxWidth='xl'>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <ProductImage assets={item.assets} />
        </Grid>
        <Grid item xs={12} md={6}>
          <Toolbar
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <ItemDetailsOptions />
          </Toolbar>
          <GenericItemInformation item={item} />
        </Grid>
        <Grid item xs={12}>
          <DetailedItemInformation item={item} />
        </Grid>
      </Grid>
    </Container>
  );
};

export default ItemDetails;
